const content = `
AI tools have drastically reduced the cost of writing code, but the cost of verifying it hasn't moved. The bottleneck isn't writing code anymore – it's verifying it.

Verification is still mostly manual: navigate through flows, check edge cases, compare against what you expected. It's slow and biased. You test what you just touched. You wrote the task, you watched it get built. You already believe it works.

I was writing code faster than I could verify it. So I changed how I verify changes. The process is three steps.

## Draft the QA plan

The agent reviews the changes and generates testing scenarios with expected behavior. I review and iterate with it on the QA plan – adding context it's missing, flagging edge cases it didn't think to cover. The agent sees the code change clearly. I understand the product intent, what users actually do, and where things have broken before. The back and forth results in a better plan than what either of us would write alone.

## Execute in the browser

The agent runs through each scenario using browser tools – navigating flows, interacting with the UI, observing what happens, taking screenshots when relevant. I'll typically switch to another worktree and start on the next thing while it runs.

## Document findings

The agent then populates its findings in a results table with a status (pass/fail/partial), observations on the outcome and how it compares to the expected behavior, and screenshots. That output goes directly into the pull request.

I run this as a \`/qa\` skill – a markdown file that loads into the agent's context when you invoke it with a slash command, reusable across any project.

It saves me a ton of time in manual QA and increases my confidence in what I ship because it can cover more cases than I'd realistically test myself, while I'm already working on the next thing.

It's also helped me get to root causes faster. The agent has flagged things during QA that pointed me toward a better fix than the one I was already planning.

Using AI to verify AI-written code sounds circular. It isn't. The reviewer runs in a fresh context with explicit instructions to be critical – not continuing the same task, not optimizing for completion. Different mode, different things caught.

Writing code got faster. Turns out making sure it works can too.
`;

export default content;
